class HamburgerMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const humBtn = document.querySelector('.js-hum');
    const humMenu = document.querySelector('.humMenu');
    const body = document.querySelector('body');
    const item01 = document.querySelector('.item1')
    const item02 = document.querySelector('.item2')
    const item03 = document.querySelector('.item3')
    const item04 = document.querySelector('.item4')
    const item05 = document.querySelector('.item5')
    const item06 = document.querySelector('.item6')
    const item07 = document.querySelector('.item7')
    const item08 = document.querySelector('.item8')

    humBtn.addEventListener('click', ()=> {
      humMenu.classList.toggle('is-active');
      humBtn.classList.toggle('is-active');
      body.classList.toggle('no-scroll');
      setTimeout(() => {
        item01.classList.toggle('is-active');
      },580);
      setTimeout(() => {
        item02.classList.toggle('is-active');
      },630);
      setTimeout(() => {
        item03.classList.toggle('is-active');
      },680);
      setTimeout(() => {
        item04.classList.toggle('is-active');
      },730);
      setTimeout(() => {
        item05.classList.toggle('is-active');
      },780);
      setTimeout(() => {
        item06.classList.toggle('is-active');
      },830);
      setTimeout(() => {
        item07.classList.toggle('is-active');
      },930);
      setTimeout(() => {
        item08.classList.toggle('is-active');
      },930);
    })
  }
}
